import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio-check",
  "use": "icon-radio-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio-check\">\n    <circle cx=\"12\" cy=\"12\" fill=\"currentColor\" r=\"12\" />\n    <path d=\"M17.3 7.7l1.3 1.4-7.6 7.5-5-5 1.2-1.3 3.8 3.8z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol